import type { CSSProperties } from 'react';
import type { Verdict } from '@visionqc/shared';

const VERDICT_CLASS: Record<string, string> = {
  GOOD: 'good',
  BAD: 'bad',
  UNSURE: 'unsure',
};

export function VerdictBadge({ verdict }: { verdict: Verdict | null }) {
  // A classification inspection has no verdict to badge — it names a class.
  // Rendering nothing is right: the alternative was a badge reading "null", or
  // the old fallback painting an absent verdict red as if it were BAD.
  if (!verdict) return null;
  return <span className={`badge ${VERDICT_CLASS[verdict] ?? 'bad'}`}>{verdict}</span>;
}

export function StatTile({
  label,
  value,
  tone,
}: {
  label: string;
  value: string | number;
  /** A CSS colour for the tile's accent and number. Defaults to the accent blue. */
  tone?: string;
}) {
  return (
    <div className="stat-tile" style={tone ? ({ ['--tone']: tone } as CSSProperties) : undefined}>
      <div className="stat-value">{value}</div>
      <div className="stat-label">{label}</div>
    </div>
  );
}

export function ProductPicker({
  products,
  value,
  onChange,
}: {
  products: { id: number; name: string }[];
  value: number | undefined;
  onChange: (id: number | undefined) => void;
}) {
  return (
    <select
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value ? Number(e.target.value) : undefined)}
    >
      <option value="">All products</option>
      {products.map((p) => (
        <option key={p.id} value={p.id}>
          {p.name}
        </option>
      ))}
    </select>
  );
}
